import importerStore from '@shared/importer/importer-store';
import { NewsletterService } from '@modules/newsletter/newsletter-service';
import newsletterImporterFields from '@modules/newsletter/newsletter-importer-fields';
import { i18n } from '@shared/i18n';

export default importerStore(
  NewsletterService.import,
  newsletterImporterFields,
  i18n('entities.newsletter.importer.fileName'),
  i18n('entities.newsletter.importer.hint'),
);
